// Utilidad para mostrar diálogos de confirmación
export var showConfirmDialog = function (swalInstance, options) {
    return swalInstance({
        title: options.title,
        html: "\n      <div class=\"text-left\">\n        <p class=\"mb-3\">\u00BFEst\u00E1 seguro de que desea eliminar <strong>\"".concat(options.itemName, "\"</strong>?</p>\n        <div class=\"alert alert-warning mb-0\">\n          <i class=\"feather icon-alert-triangle mr-1\"></i>\n          <strong>Advertencia:</strong> Esta acci\u00F3n no se puede deshacer.\n        </div>\n      </div>\n    "),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="feather icon-trash-2 mr-1"></i> Sí, eliminar',
        cancelButtonText: '<i class="feather icon-x mr-1"></i> Cancelar',
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        reverseButtons: true,
        customClass: {
            popup: 'swal2-popup-custom',
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-secondary'
        }
    });
};
